export {};

const prevArrow = NLMK.generateSlickArrow('left', 'prev');
const nextArrow = NLMK.generateSlickArrow('right', 'next');

$(init);

NLMK.initSliders = init;

function init() {
    $('.slider--widgets').each(eachSlider);
}

function eachSlider(sliderIndex, SliderElement) {
    const $slider = $(SliderElement);
    const $list = $slider.find('.slider__list');

    const slidesRowsVerticalTablet = $list.data('slides-rows-vertical-tablet') || 1;
    const slidesToShowVerticalTablet = $list.data('slides-to-show-vertical-tablet') || 2;
    const slidesToShow = $list.data('slides-to-show') || 3;
    const infinite = $list.data('infinite');

    let Instance;

    const config = {
        dots: false,
        arrows: true,
        infinite: typeof infinite !== 'undefined' && !!infinite,
        prevArrow,
        nextArrow,
    };

    const finalConfig = $.extend(true, {}, config, {
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    dots: true,
                    rows: slidesToShow,
                    slidesPerRow: 1,
                },
            },
            {
                breakpoint: NLMK.mediaQueries.verticalTablet.min - 1,
                settings: {
                    slidesToScroll: slidesToShowVerticalTablet,
                    slidesToShow: slidesToShowVerticalTablet,
                    slidesPerRow: slidesToShowVerticalTablet,
                    rows: slidesRowsVerticalTablet,
                },
            },
            {
                breakpoint: NLMK.mediaQueries.horizontalTablet.min - 1,
                settings: {
                    rows: slidesToShow,
                    slidesPerRow: 1,
                },
            },
            {
                breakpoint: NLMK.mediaQueries.desktop.min - 1,
                settings: {
                    rows: slidesToShow,
                    slidesPerRow: 1,
                },
            },
        ],
    });

    let currentSlide = 0;

    $list
        .on('init', (evt, Slick) => {
            Instance = Slick;

            $(window).on(NLMK.events.TABS_CHANGE, () => Instance.refresh());

            Instance.$nextArrow.on('click', () => {});
        })
        .on('beforeChange', () => {
            $slider.addClass('transitioning');
        })
        .on('afterChange', () => {
            $slider.removeClass('transitioning');

            currentSlide = Instance.currentSlide;
        })
        .slick(finalConfig);
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/widgets.js